module.exports = __webpack_public_path__ + "static/media/logo-asisa-collapsed-white.77cdca61.svg";